
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 7.122 7.898"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_44905","data-name":"Group 44905","transform":"translate(-98.654 -154.148)"}},[_c('path',{attrs:{"id":"Polygon_16","data-name":"Polygon 16","d":"M3.133.4a.5.5 0 01.733 0l2.356 2.536a.5.5 0 01-.367.84h-4.71a.5.5 0 01-.367-.84z","transform":"rotate(90 -24.186 129.962)","fill":"#727998"}}),_c('path',{attrs:{"id":"Path_30598","data-name":"Path 30598","d":"M104.497 157.648h-3.622a1.621 1.621 0 00-1.621 1.621v2.654","fill":"none","stroke":"#727998","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.2"}})])])
          )
        }
      }
    